import * as React from 'react';
import { Resizable, type ResizeCallbackData } from 'react-resizable';

export type DrawerLineTableResizableTitleProps =
  React.ThHTMLAttributes<HTMLTableCellElement> & {
    width?: number;
    onResize?: (
      e: React.SyntheticEvent,
      data: ResizeCallbackData
    ) => void;
    onResizeStop?: (
      e: React.SyntheticEvent,
      data: ResizeCallbackData
    ) => void;
    minWidth?: number;
    resizeAriaLabel?: string;
  };

/**
 * Ant Table header cell with a right-edge drag handle for column width.
 * Non-resizable columns (no width) render a plain `th`.
 */
export const DrawerLineTableResizableTitle: React.FC<
  DrawerLineTableResizableTitleProps
> = ({
  onResize,
  onResizeStop,
  width,
  minWidth = 40,
  resizeAriaLabel = 'Drag to resize column',
  children,
  ...restProps
}) => {
  if (width == null || !onResize) {
    return <th {...restProps}>{children}</th>;
  }

  return (
    <Resizable
      width={width}
      height={0}
      minConstraints={[minWidth, 0]}
      maxConstraints={[640, 0]}
      handle={
        <span
          className="drawer-table-col-resize-handle"
          onClick={(e) => e.stopPropagation()}
          role="separator"
          aria-orientation="vertical"
          aria-label={resizeAriaLabel}
        />
      }
      onResize={onResize}
      onResizeStop={onResizeStop}
      draggableOpts={{ enableUserSelectHack: false }}
    >
      <th {...restProps}>{children}</th>
    </Resizable>
  );
};
